import { Component, Inject, InjectionToken, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

var ADSENSE_CONFIG = new InjectionToken('AdsenseConfig');
var AdsenseComponent = /** @class */ (function () {
    /**
     * @param {?} config
     */
    function AdsenseComponent(config) {
        this.config = config;
        /**
         * can be manually set if you need all ads on a page to have same id page-xxx
         */
        this.adRegion = 'page-' + Math.floor(Math.random() * 10000) + 1;
    }
    /**
     * @return {?}
     */
    AdsenseComponent.prototype.ngOnInit = function () {
        var /** @type {?} */ config = this.config;
        /**
         * @template T
         * @param {?} source
         * @param {?} defaultValue
         * @return {?}
         */
        function use(source, defaultValue) {
            return config && source !== undefined ? source : defaultValue;
        }
        this.adClient = use(this.adClient, config.adClient);
        this.adSlot = use(this.adSlot, config.adSlot);
        this.adFormat = use(this.adFormat, config.adFormat || 'auto');
        this.display = use(this.display, config.display || 'block');
        this.width = use(this.width, config.width);
        this.height = use(this.height, config.height);
        this.layout = use(this.layout, config.layout);
        this.layoutKey = use(this.layoutKey, config.layoutKey);
    };
    /**
     * attempts to push the ad twice. Usually if one doesn't work the other
     * will depeding on if the browser has the adsense code cached and
     * if its the first page to be loaded
     * @return {?}
     */
    AdsenseComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        var /** @type {?} */ res = this.push();
        if (res instanceof TypeError) {
            setTimeout(function () { return _this.push(); }, 200);
        }
    };
    /**
     * @return {?}
     */
    AdsenseComponent.prototype.push = function () {
        try {
            var /** @type {?} */ adsbygoogle = window['adsbygoogle'];
            adsbygoogle.push({});
            return true;
        }
        catch (e) {
            return e;
        }
    };
    AdsenseComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ng2-adsense,ng-adsense',
                    template: "\n  <ins class=\"adsbygoogle\"\n    [ngStyle]=\"{'display': display, 'width.px': width, 'height.px': height }\"\n    [attr.data-ad-client]=\"adClient\"\n    [attr.data-ad-slot]=\"adSlot\"\n    [attr.data-ad-format]=\"adFormat\"\n    [attr.data-ad-region]=\"adRegion\"\n    [attr.data-layout]=\"layout\"\n    [attr.data-layout-key]=\"layoutKey\">\n  </ins>\n  ",
                },] },
    ];
    /**
     * @nocollapse
     */
    AdsenseComponent.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [ADSENSE_CONFIG,] },] },
    ]; };
    AdsenseComponent.propDecorators = {
        'adClient': [{ type: Input },],
        'adSlot': [{ type: Input },],
        'adFormat': [{ type: Input },],
        'adRegion': [{ type: Input },],
        'display': [{ type: Input },],
        'width': [{ type: Input },],
        'height': [{ type: Input },],
        'layout': [{ type: Input },],
        'layoutKey': [{ type: Input },],
    };
    return AdsenseComponent;
}());
var AdsenseModule = /** @class */ (function () {
    function AdsenseModule() {
    }
    /**
     * @param {?=} config
     * @return {?}
     */
    AdsenseModule.forRoot = function (config) {
        if (config === void 0) { config = {}; }
        return {
            ngModule: AdsenseModule,
            providers: [{ provide: ADSENSE_CONFIG, useValue: config }],
        };
    };
    AdsenseModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule],
                    exports: [AdsenseComponent],
                    declarations: [AdsenseComponent],
                },] },
    ];
    /**
     * @nocollapse
     */
    AdsenseModule.ctorParameters = function () { return []; };
    return AdsenseModule;
}());

/**
 * Generated bundle index. Do not edit.
 */

export { ADSENSE_CONFIG, AdsenseComponent, AdsenseModule };
//# sourceMappingURL=ng2-adsense.es5.js.map



//////////////////
// WEBPACK FOOTER
// ./~/ng2-adsense/ng2-adsense.es5.js
// module id = 33
// module chunks = 0 1